import { AxiosRequestConfig } from 'axios'
import {
  CloseAccountRequest,
  LostStolenCardAcceptedResponse,
  LostStolenCardRequest,
  LostStolenCardResponse
} from 'services/accountManagement/typings'
import apiEndpoints from 'const/endPoint'
import { getHeaderParams } from 'helpers/requestParams'
import apiRequestor from 'services/apiRequestor'

const accountsManagement = {
  putCloseAccount: async (payload: CloseAccountRequest): Promise<void> => {
    const { accessToken, requestBody } = payload
    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.closeAccount,
      method: 'PUT',
      headers: { ...headerParams },
      data: {
        ...requestBody
      }
    }

    const response = await apiRequestor<void>({
      requestConfig,
      hasAccountInfo: false,
      moduleType: 'USER'
    })

    return response.data
  },
  putLostStolen: async (
    payload: LostStolenCardRequest
  ): Promise<LostStolenCardResponse | LostStolenCardAcceptedResponse> => {
    const { accessToken, requestBody } = payload
    const headerParams = getHeaderParams(accessToken)

    const requestConfig: AxiosRequestConfig = {
      url: apiEndpoints.lostCard,
      method: 'PUT',
      headers: { ...headerParams },
      data: {
        ...requestBody
      }
    }

    const response = await apiRequestor<
      LostStolenCardResponse | LostStolenCardAcceptedResponse
    >({
      requestConfig,
      hasAccountInfo: false
    })

    return response.data
  }
}

export default accountsManagement
